module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/072-bonaire-d93b45a78c33b9ed6e8d83a0a8e97e7f.svg";